import type { ReactNode } from 'react'

// Shared prose primitives for the four legal pages, so heading/paragraph/list
// treatment is identical across Privacy, Cookies, Terms and Accessibility
// rather than four copies of the same className strings.

export function Section({ heading, children }: { heading: string; children: ReactNode }) {
    return (
        <div className="border-t border-unimo-site-grey-300 pt-8 first:border-t-0 first:pt-0">
            <h2 className="text-2xl font-medium text-unimo-slate">{heading}</h2>
            <div className="mt-4 space-y-4 font-light leading-relaxed text-unimo-slate">{children}</div>
        </div>
    )
}

export function SubHeading({ children }: { children: ReactNode }) {
    return <h3 className="text-lg font-medium text-unimo-slate">{children}</h3>
}

export function List({ children }: { children: ReactNode }) {
    return <ul className="list-disc space-y-1 pl-5">{children}</ul>
}

export function TableWrap({ children }: { children: ReactNode }) {
    return (
        <div className="overflow-x-auto">
            <table className="w-full min-w-[480px] border-collapse text-sm">{children}</table>
        </div>
    )
}

export function Th({ children }: { children: ReactNode }) {
    return (
        <th className="border border-unimo-site-grey-300 bg-white p-2 text-left align-top font-medium">
            {children}
        </th>
    )
}

export function Td({ children }: { children: ReactNode }) {
    return <td className="border border-unimo-site-grey-300 p-2 text-left align-top">{children}</td>
}

export function LegalLink({ href, children }: { href: string; children: ReactNode }) {
    return (
        <a href={href} className="underline underline-offset-2">
            {children}
        </a>
    )
}
